import { Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { updateCampaign } from "../../pages/campaigns/campaignSlice";

const DetailsButtons = () => {
    const location = useLocation();
    const { id } = useParams()
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {
        campaignInfluencersList, formData
    } = useSelector((state) => state.campaignSlice)

    const handleButtonClick = (url,stateObj=null)=>{
         dispatch(updateCampaign({ page: 0 }));
         if(stateObj){
             navigate(url,{state:stateObj})
         } else{
              navigate(url)
         }
    }


    return <Stack direction="row" className="viewDetTabs mt-0 campaignDetails">
        <button className={location?.pathname?.split("/")?.includes("campaign") ? "active" : ""}
            onClick={() => {
                // navigate("/campaign/partial/details/" + id)
                handleButtonClick("/campaign/partial/details/" + id)
                // if (getUserType() === "admin") {
                //     navigate("/campaign/details/" + id);
                // } else {
                //     navigate("/campaign/partial/details/" + id)
                // }
            }}
        >
            Details
        </button>
        <button className={location?.pathname?.split("/")?.includes("influencer") ? "active" : ""}
            onClick={() => handleButtonClick("/my-campaigns/influencer/" + id,{ state: { campaignName: formData.name }})}
        >
            Influencer’s Applications{campaignInfluencersList?.length > 0 && location?.pathname?.split("/")?.includes("influencer") ? <span> {campaignInfluencersList?.length}</span> : ''}
        </button>
        <button className={location?.pathname?.split("/")?.includes("negotiated-influencers") ? "active" : ""}
            onClick={() => handleButtonClick("/my-campaigns/negotiated-influencers/" + id,{ state: { campaignName: formData.name, type: formData.type } })}
        >
            Negotiated Influencers {campaignInfluencersList?.length > 0 && location?.pathname?.split("/")?.includes("negotiated-influencers") ? <span> {campaignInfluencersList?.length}</span> : ''}
        </button>

        <button className={location?.pathname?.split("/")?.includes("approved-influencer") ? "active" : ""}
            onClick={() => handleButtonClick(`/my-campaigns/approved-influencer/${id}`)}
        >
            Approved Influencers{campaignInfluencersList?.campaignContent?.length > 0 && location?.pathname?.split("/")?.includes("approved-influencer") ? <span> {campaignInfluencersList?.campaignContent?.length} </span> : ''}
        </button>

    </Stack >
}

export default DetailsButtons;